import { inject as service } from '@ember/service';
import Controller, { inject as controller } from '@ember/controller';
import deserialize from 'cio/utils/conditions/deserialize';
import AuthService from 'cio/services/auth';
import FeaturesService from 'ember-feature-flags/services/features';
import ApiErrorsService from 'cio/services/api-errors';
import SegmentController from 'cio/pods/segments/segment/controller';
import SegmentModel from 'cio/models/segment';
import GroupCondition from 'cio/app-models/conditions/group';

export default class IndexController extends Controller {
  @service auth!: AuthService;
  @service features!: FeaturesService;
  @service apiErrors!: ApiErrorsService;

  declare model: SegmentModel;

  // @ts-ignore: injected controller not typed, not in the controller registry
  @controller('segments.segment') segmentController!: SegmentController;

  conditionTree: GroupCondition | null = null;

  extractConditionTree() {
    let conditionTree = deserialize(this.model.conditions);
    this.set('conditionTree', conditionTree);
  }
}

declare module '@ember/controller' {
  interface Registry {
    'segments.segment.overview.index': IndexController;
  }
}
